import { useState } from "react";

export const useRadioGroup = (defaultValue) => {
  const [selectedOption, setSelectedOption] = useState(defaultValue);

  const handleChange = (value) => {
    setSelectedOption(value);
  };

  return { selectedOption, handleChange };
};
